import { render, staticRenderFns } from "./ManufacturersForm.vue?vue&type=template&id=a40c1972"
import script from "./ManufacturersForm.vue?vue&type=script&lang=js"
export * from "./ManufacturersForm.vue?vue&type=script&lang=js"
import style0 from "./ManufacturersForm.vue?vue&type=style&index=0&id=a40c1972&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports